<app-table-drag tableName="first"
                [tableData]="tableDataFirst"
                [dragDropManager]="dragDropManagerService.manager">
</app-table-drag>


<app-table-drag tableName="second"
                [tableData]="tableDataSecond"
                [dragDropManager]="dragDropManagerService.manager">
</app-table-drag>


<app-table-drag tableName="third"
                [tableData]="tableDataThird"
                [dragDropManager]="dragDropManagerService.manager">
</app-table-drag>

